import { useEffect } from "react";

import { BrowserRouter } from "react-router-dom";

import GlobalStyle from "./global/styles";
import { Router } from "./routers";
import { LogOperation } from "./utils/entities/logOperation";

function App() {
  useEffect(() => {
    (async () => {
      await LogOperation.setMachineIP();
    })();
  }, []);

  return (
    <BrowserRouter>
      <Router />
      <GlobalStyle />
    </BrowserRouter>
  );
}

export default App;
